import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=67a5b2d0&scoped=true&"
import script from "./StepTwo.vue?vue&type=script&lang=js&"
export * from "./StepTwo.vue?vue&type=script&lang=js&"
import style0 from "./StepTwo.vue?vue&type=style&index=0&id=67a5b2d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5b2d0",
  null
  
)

export default component.exports